import yup from "src/validators/yup.Module";

export interface TributacaoFiltrarDto {
  tipoFiltro?: number;
  valor?: string;
  padraoEmissaoCupomFiscal?: boolean;
  PadraoEmissaoCTe?: boolean;
  padraoEmissaoCTe?: boolean;
}

export interface TributacaoDto {
  id: number;
  nome: string;
  naturezaOperacao: string;
  tipoOperacao: number;
  tipoOperacaoDescricao: string;
  padraoEmissaoCupomFiscal: boolean;
  padraoEmissaoCTe?: boolean;
  cfop: TributacaoCfopDto[];
}

export interface TributacaoCfopDto {
  id: number;
  tributacaoId: number;
  cfop: string;
  tipoParametro: number;
  tipoParametroDescricao: string;
  parametroValor: number;
}

export const TributacaoFiltrarSchema = yup.object().shape({
  //   nome: yup
  //     .string()
  //     .notRequired()
  //     .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
